export default function ({ $auth, redirect }) {
  if (!$auth.user.data || !$auth.user.data.roles.includes('admin')) {
    return redirect('/')
  }
}
